import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  let isGotoNext = true;
  //---set token and auth
  if ((to.name === 'home' || to.name === 'dashboard') && to.query.hasOwnProperty('token')) {
    store.commit('AUTH/AUTH_PTF_TOKEN_SET', to.query.token);
    store.commit('AUTH/AUTH_ROUTES_SET', {
      to: to,
      from: from
    });
    store.dispatch('AUTH/AUTH_LOGIN_REQUEST');
    store.commit('APP/APP_POPUP_OPEN', 'popupLogin');
  }
  //---check auth
  if (
      to.matched.some(record => record.meta.requiresAuth) &&
      (!store.getters['AUTH/user'] || store.getters['AUTH/user'] && !store.getters['AUTH/user'].enablePtfSalesView)
    ) {

      store.commit('AUTH/AUTH_ROUTES_SET', {
        to: to,
        from: from
      });
      store.commit('APP/APP_POPUP_OPEN', 'popupLogin');
      isGotoNext = false;
    }

  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'instant'
  });

  if (isGotoNext) {
    next();
  }
});

export default router